class ShopFeed extends HTMLElement{
    constructor() {
        super();
        this.currentVideoPlayer = null;
        this.addEventListener(
            'video_playing',
            this.handleVideoPlaying.bind(this)
        );

        this.addEventListener('video_paused', (e) => {
            if (this.currentVideoPlayer === e.target) {
                this.currentVideoPlayer = null;
            }
        });
        HELPER_UTIL.trigerElementFunctionalityInView(
            this,
            null,
            this.checkInView.bind(this)
        );

        // Pause feed video if options drawer opens
        document.addEventListener(_EVENT_HELPER.showDrawer, (e) => {
            if (e.detail.drawerType !== 'options') return;
            this.checkAndPauseAnyVideoPlaying();
       });
    }

    handleVideoPlaying(e) {
        const newVideoPlayer = e.target;
        if (!this.currentVideoPlayer) {
            this.currentVideoPlayer = newVideoPlayer;
        }
        else if (this.currentVideoPlayer && this.currentVideoPlayer != newVideoPlayer) {
            this.currentVideoPlayer._pause();
            this.currentVideoPlayer = newVideoPlayer;
        }
    }

    checkAndPauseAnyVideoPlaying() {
         if (!this.currentVideoPlayer) return;
         this.currentVideoPlayer._pause();
    }

    checkInView() {
        this.checkAndPauseAnyVideoPlaying();
    }

}

customElements.get('shop-feed') || customElements.define('shop-feed', ShopFeed);

class ShoppableFeedCard extends HTMLElement {
    constructor(){
        super();
        this.mediaPlayElement = this.querySelector('[media-interaction-element]');
    }

    initCommonEventListeners(){
        this.mediaPlayElement && this.mediaPlayElement.addEventListener("click", (e) => {
            console.log("User clicked on playable area");
        })
    }

    connectedCallback(){
        this.initCommonEventListeners();
    }

    disconnectedCallback(){

    }
}

customElements.get('shoppable-feed-card') ||
    customElements.define('shoppable-feed-card', ShoppableFeedCard);
class FeedPlayer extends defaultVideoPlayer {
    constructor() {
        super();
        this.pauseVideoEl = this.querySelectorAll('[pause-media]');
        this.audioEl = this.querySelector('[audio-state]');
        this.pauseVideoEl &&
            this.pauseVideoEl.forEach((el) =>
                el.addEventListener('click', this.whenVideoPause.bind(this))
            );
        this.audioEl && this.audioEl.addEventListener('click', this.handleAudioState.bind(this));
    }

    handleAudioState() {
        const audioState = this.audioEl.getAttribute('audio-state');
        switch (audioState) {
            case 'mute':
                this.audioEl.setAttribute('audio-state', 'unmute');
                this.player.muted = false;
                break;
            case 'unmute':
                this.audioEl.setAttribute('audio-state', 'mute');
                this.player.muted = true;
                break;
            case 'default':
                break;
        }
    }


    whenVideoPause() {
        this._pause();
        // this.showPlayButton();
    }
    
    _pause() {
        super._pause();
        this.setAttribute("video-playing", false)
        HELPER_UTIL.dispatchCustomEvent('video_paused', this);
    }

    _play() {
        HELPER_UTIL.dispatchCustomEvent('video_playing', this);
        super._play();
        this.setAttribute("video-playing", true);
        
    }

    showPlayButton() {
        this.playButton.classList.remove('video-elements-hidden');
    }
}

customElements.get('feed-player') || customElements.define('feed-player', FeedPlayer);
//# sourceMappingURL=section-shoppable-feed.js.map
